import { render, staticRenderFns } from "./ActHome.vue?vue&type=template&id=150b84d7&scoped=true&"
import script from "./ActHome.vue?vue&type=script&lang=js&"
export * from "./ActHome.vue?vue&type=script&lang=js&"
import style0 from "./ActHome.vue?vue&type=style&index=0&id=150b84d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b84d7",
  null
  
)

export default component.exports